import {
  calcSubtotalQuote,
  CalcularAdministracion,
  CalcularDescuento,
  CalcularImprevistos,
  CalcularIvaUtilidad,
  CalcularSubTotal,
  CalcularUtilidad,
  formatMoney,
} from "../Utili";

const Aiu = ({ doc }) => {
  const {
    articulos = [],
    descuento = 0,
    iva_utilidad = 0,
    imprevistos = 0,
    administracion = 0,
    utilidad = 0,
    tipo
  } = doc;

  const subtotal = calcSubtotalQuote(articulos,tipo);
  const totalAdministracion = CalcularAdministracion(subtotal, administracion);
  const totalImprevistos = CalcularImprevistos(subtotal, imprevistos);
  const totalUtilidad = CalcularUtilidad(subtotal, utilidad);
  const totalIvaUtilidad = CalcularIvaUtilidad(totalUtilidad, iva_utilidad);
  const totalDescuento = CalcularDescuento(subtotal, descuento);

  const total = () => {
    return (
      subtotal +
      totalAdministracion +
      totalImprevistos +
      totalUtilidad +
      totalIvaUtilidad
    );
  };

  const total2 = () => {
    return total() - totalDescuento;
  };

  return (
    <>
      <tr>
        <td colSpan={tipo=='M' ? 4:3}></td>
        <th align="left" style={{ background: "silver", padding: 1 }}>
          SUBTOTAL
        </th>
        <td align="right" style={{ padding: 1 }}>
          <span style={{ fontSize: 20, fontWeight: 500 }}>${formatMoney(subtotal)}</span>
        </td>
      </tr>
      <tr>
        <td colSpan={tipo=='M' ? 4:3}></td>
        <th align="left" style={{ background: "silver", padding: 1 }}>
          ADMINISTRACIÓN {administracion}%
        </th>
        <td align="right" style={{ padding: 1 }}>
          <span style={{ fontSize: 20, fontWeight: 500 }}>${formatMoney(totalAdministracion)}</span>
        </td>
      </tr>
      <tr>
        <td colSpan={tipo=='M' ? 4:3}></td>
        <th align="left" style={{ background: "silver", padding: 1 }}>
          IMPREVISTOS {imprevistos} %
        </th>
        <td align="right" style={{ padding: 1 }}>
          <span style={{ fontSize: 20, fontWeight: 500 }}>${formatMoney(totalImprevistos)}</span>
        </td>
      </tr>
      <tr>
        <td colSpan={tipo=='M' ? 4:3}></td>
        <th align="left" style={{ background: "silver", padding: 1 }}>
          UTILIDAD {utilidad} %
        </th>
        <td align="right" style={{ padding: 1 }}>
          <span style={{ fontSize: 20, fontWeight: 500 }}>${formatMoney(totalUtilidad)}</span>
        </td>
      </tr>
      <tr>
        <td colSpan={tipo=='M' ? 4:3}></td>
        <th align="left" style={{ background: "silver", padding: 1 }}>
          IVA/Utilidad {iva_utilidad} %
        </th>
        <td align="right" style={{ padding: 1 }}>
          <span style={{ fontSize: 20, fontWeight: 500 }}>${formatMoney(totalIvaUtilidad)}</span>
        </td>
      </tr>
      <tr>
        <td colSpan={tipo=='M' ? 4:3}></td>
        <th align="left" style={{ background: "silver", padding: 1 }}>
          SUBTOTAL
        </th>
        <td align="right" style={{ padding: 1 }}>
          <span style={{ fontSize: 20, fontWeight: 500 }}>${formatMoney(total())}</span>
        </td>
      </tr>
      {totalDescuento > 0 ? (
        <tr>
          <td colSpan={tipo=='M' ? 4:3}></td>
          <th align="left" style={{ background: "silver", padding: 1 }}>
            DESCUENTO {descuento} %
          </th>
          <td align="right" style={{ padding: 1 }}>
            <span style={{ fontSize: 20, fontWeight: 500 }}>${formatMoney(totalDescuento)}</span>
          </td>
        </tr>
      ) : null}
      <tr>
        <td colSpan={tipo=='M' ? 4:3}></td>
        <th align="left" style={{ background: "silver", padding: 1 }}>
          TOTAL
        </th>
        <td align="right" style={{ padding: 1 }}>
          <span style={{ fontSize: 20, fontWeight: 500 }}>{formatMoney(total2())}</span>
        </td>
      </tr>
    </>
  );
};

export default Aiu;
